const TEST_ITEM = 'testItem';

const isLocalStorageAccessible = ((): boolean => {
  try {
    localStorage.setItem(TEST_ITEM, TEST_ITEM);
    const item = localStorage.getItem(TEST_ITEM);
    localStorage.removeItem(TEST_ITEM);

    return item === TEST_ITEM;
  } catch (e) {
    return false;
  }
})();

const checkLocalStorage = (): void => {
  if (!isLocalStorageAccessible) {
    throw new Error('Local storage is not accessible');
  }
};

const setItem = (key: string, value: string): void => {
  checkLocalStorage();
  localStorage.setItem(key, value);
};

const getItem = (key: string): string | null => {
  checkLocalStorage();

  return localStorage.getItem(key);
};

const removeItem = (key: string): void => {
  checkLocalStorage();
  localStorage.removeItem(key);
};

export { setItem, getItem, removeItem };
